import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  env = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public http: HttpClient,
    public toastr: ToastrService) {  
  }

  public subject = new Subject<any>();
  public sendMessage(command: string,message: string) {
    this.subject.next({
        command : command,
        text: message 
    });
  }
  
  public getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  public goto(page){
    try {
      this.router.navigate([page], { relativeTo: this.route });
    } catch (error) {
    }
  }

  getConfig(){
    return JSON.parse(sessionStorage.getItem('config'));
  }
  
  checkPermission(permissonName){
    for(var i = 0;i < permissonName.length;i++){
      try {
        if(this.getConfig().scope.includes(permissonName[i])){
          return true;
        }
      } catch (error) {
        return true;
      }
     
    }
    return false;
  }

  //serverURL
  getUrl(){
    return this.env.url;
  }

  // http get data
  getHtpp(url,header){
    if(!header){
      header = {
        headers: {
          'content-type' : 'application/json',
          'authorization' : 'Bearer ' + this.getConfig().access_token
        }
      }
    }
    return new Promise((resolve, reject)=> this.http.get(this.env.url+url,header).subscribe((data)=>{
      resolve(data);
    }));
  }

  postHtpp(url,body){
    const options = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.getConfig().access_token
      })
    };
    return new Promise((resolve, reject)=> this.http.post(this.env.url+url, body, options).subscribe((req)=>{
      resolve(req);
    }, (error) => {
      console.log(error);
      reject(error);
    }));
  }

  postHtppLogin(url,body){
    const options = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
    };
    return new Promise((resolve, reject)=> this.http.post(this.env.url+url, body, options).subscribe((req)=>{
      resolve(req);
    }, (error) => {
      console.log(error);
      reject(error);
    }));
  }


  putHtpp(url,body,header){
    if(!header){
      header = {
        headers: {
          'content-type' : 'application/json',
          'authorization' : 'Bearer ' + this.getConfig().access_token
        }
      }
    }
    return new Promise((resolve, reject)=> this.http.put(this.env.url+url, body, header).subscribe((req)=>{
      resolve(req);
    }, (error) => {
      console.log(error);
      reject(error);
    }));
  }

  deleteHtpp(url){
    const options = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization' : 'Bearer ' + this.getConfig().access_token
      })
    }
    return new Promise((resolve, reject)=> this.http.delete(this.env.url+url,options).subscribe((req)=>{
      resolve(req);
    }, (error) => {
      console.log(error);
      reject(error);
    }));
  }

  checkinput(text,command,number){
    if(command == '==' && text){
      if(text.length == number){
        return true;
      } else {
        return false;
      }
    } else if(command == '>' && text){
      if(text.length > number){
        return true;
      } else {
        return false;
      }
    } else if(command == '<' && text){
      if(text.length < number){
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};
  
    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }
  
    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
  }

  public showAttr(data,name){
    if(data){
      for (var key in data) {
        if(key == name){
          return data[key];
        }
      }
      return '';
    }else{
      return ''
    }
  }



}
